/**
 * AuthLayout: wrapper para rutas autenticadas del portal vecino.
 *
 * Sprint 11 v2 S11-V2-03. Replica la estructura `.cb-wrap > .cb-portal`
 * del handoff: container max-w 1024px + portal con borde + Header
 * naranja + (espacio para Greeting según ruta) + Outlet para contenido +
 * Footer negro.
 *
 * El Greeting NO se renderiza acá; cada página decide si lo muestra y
 * con qué eyebrow/title/meta. El Dashboard (S11-V2-05) lo usa con
 * Greeting split (alerta a la derecha cuando aplica); Mi cuenta y Mis
 * datos lo usan en modo simple; algunas vistas admin pueden no usarlo.
 */
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../lib/auth/AuthContext';
import { Header } from './Header';
import { Footer } from './Footer';
import { BottomNav } from './BottomNav';

export function AuthLayout() {
  const { me } = useAuth();
  if (!me) return null;

  return (
    <div className="min-h-screen bg-bg-page pb-16 md:pb-0">
      <div className="max-w-portal mx-auto p-2 sm:p-4 md:p-6 lg:p-10">
        <div className="bg-bg-card border-[0.5px] border-white/[0.08] rounded-lg overflow-hidden">
          <Header me={me} />
          <Outlet />
          <Footer />
        </div>
      </div>
      <BottomNav me={me} />
    </div>
  );
}
